export function errorFetching (state, value) {
  state.errorFetching = value
}

export function loading (state, value) {
  state.loading = value
}

export function query (state, value) {
  state.errorFetching = false
  state.query = value
}

export function result (state, value) {
  state.result = value
}

export function results (state, value) {
  state.results = value
}

export function resultLayer (state, value) {
  state.resultLayer = value
}
